import PropTypes from 'prop-types';

import { useZohoDeskAsap } from '../../../../hooks/useZohoDeskAsap';

export default function ZohoDeskAsapManager({ enabled }) {
  useZohoDeskAsap(enabled);
  return null;
}

ZohoDeskAsapManager.propTypes = {
  enabled: PropTypes.bool,
};
